import { Linked } from "@type-r/models";
import * as React from "react";
import { OrderModel } from "api";
import { ValidatePODialog, ResetPODialog } from "./supplier";
import { UploadDialog } from "common";
import { SubmitPODialog, HoldPODialog, CancelPODialog } from "./distributor";

export type DialogType =
  | "reset"
  | "validate"
  | "upload"
  | "submit"
  | "hold"
  | "cancel";

export const ShowDialog = ({
  $dialog,
  order,
  fetchedOrder
}: {
  $dialog: Linked<DialogType>;
  order: OrderModel;
  fetchedOrder: OrderModel;
}) => {
  switch ($dialog.value) {
    case "reset":
      return <ResetPODialog $isOpen={$dialog.equals("reset")} order={order} />;

    case "validate":
      return (
        <ValidatePODialog
          $isOpen={$dialog.equals("validate")}
          order={order}
          fetchedOrder={fetchedOrder}
        />
      );

    case "submit":
      return (
        <SubmitPODialog
          $isOpen={$dialog.equals("submit")}
          order={order}
          fetchedOrder={fetchedOrder}
        />
      );

    case "hold":
      return (
        <HoldPODialog
          $isOpen={$dialog
            .equals("submit")
            // When the dialog is closed, fetch the order from the backend
            .onChange(x => x || order.fetch())}
          order={order}
        />
      );

    case "cancel":
      return (
        <CancelPODialog $isOpen={$dialog.equals("submit")} order={order} />
      );

    case "upload":
      return <UploadDialog $isOpen={$dialog.equals("upload")} model={order} />;

    default:
      return <div />;
  }
};
